import React from 'react';
import EchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie';

import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/secondary-school/layoutProps';

import styles from './index.module.scss';

const data = [
  { name: 'ICHK (20%)', value: 20 },
  { name: 'ESF Schools (18%)', value: 18 },
  { name: 'Chinese International School (9%)', value: 9 },
  { name: 'Overseas (7%)', value: 7 },
  { name: 'Creative Secondary School (14%)', value: 14 },
  { name: 'Yew Chung (5%)', value: 5 },
  { name: 'Local Schools (3%)', value: 3 },
  { name: 'Harrow (6%)', value: 6 },
  { name: 'Hong Kong Academy (4%)', value: 4 },
  { name: 'Malvern (7%)', value: 7 },
  { name: 'Other International Schools (7%)', value: 7 },
];

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="secondary-choices-of-past-graduates">
    <h1>Secondary Choices of Past Graduates</h1>
    <p>
      Even though Kingston provides a quality through-train option for secondary school (ICHK), we believe in supporting
      families who wish to choose a different path. We have strived to develop relationships with various secondary
      schools in Hong Kong and we are very proud that Kingston graduates are sought after by schools throughout the
      city. We have compiled a decade's worth of information on graduate choices of secondary education. These choices
      are compiled below:
    </p>
    <div className={styles.chart}>
      <EchartsCore
        echarts={echarts}
        option={{
          visualMap: {
            show: false,
            inRange: {
              colorLightness: [0, 1],
            },
          },

          series: [
            {
              name: 'Secondary Choices',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
              animationType: 'scale',
              animationEasing: 'elasticOut',
            },
          ],
        }}
      />
    </div>
  </ContentLayout>
);
